import { Drawer as ShadcnDrawer, DrawerContent } from '@/components/ui/drawer';

interface DrawerProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const Drawer = ({ open, onClose, children }: DrawerProps) => {
  return (
    <ShadcnDrawer open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DrawerContent>{children}</DrawerContent>
    </ShadcnDrawer>
  );
};
